import a1 from '../images/reviews/1RzFW7qm7zfz9oOn8RAsX7vtOvi1.jpg';
import a2 from '../images/reviews/aUiLF46OidegowLIPW1d7erIc7R2.jpg';
import a3 from '../images/reviews/AX8qovnIWoYzRtKKtb37Md6Rn5E3.jpg';
import a4 from '../images/reviews/BrVfMWOHt2XZK8e6NxMRqzrzX3e2.jpg';
import a5 from '../images/reviews/guL3ueiZygXNDxB0SM9j7A3T2iA2.jpg';
import a6 from '../images/reviews/K6HJj6llqGM4ehUGVcc1Bph9B0J2.jpg';
import a7 from '../images/reviews/KFBbup3fQAXhheJwfMIyeQCjS2U2.jpg';
import a8 from '../images/reviews/oMpMQuBJnia6qXeC4tjabLl1X2K2.jpg';
import a9 from '../images/reviews/v9ecqJI5EoSDyrx2JX7KHf1R2E13.jpg';
import a10 from '../images/reviews/ynHyK4FNNVN2bf3UmwVPv62r10n2.jpg';
import a11 from '../images/reviews/ZiT3aW1NIVazW5IA1XhgwUHrjqD2.jpg';

const reviewAvatars = {
  '1RzFW7qm7zfz9oOn8RAsX7vtOvi1': a1,
  aUiLF46OidegowLIPW1d7erIc7R2: a2,
  AX8qovnIWoYzRtKKtb37Md6Rn5E3: a3,
  BrVfMWOHt2XZK8e6NxMRqzrzX3e2: a4,
  guL3ueiZygXNDxB0SM9j7A3T2iA2: a5,
  K6HJj6llqGM4ehUGVcc1Bph9B0J2: a6,
  KFBbup3fQAXhheJwfMIyeQCjS2U2: a7,
  oMpMQuBJnia6qXeC4tjabLl1X2K2: a8,
  v9ecqJI5EoSDyrx2JX7KHf1R2E13: a9,
  ynHyK4FNNVN2bf3UmwVPv62r10n2: a10,
  ZiT3aW1NIVazW5IA1XhgwUHrjqD2: a11,
};

export default reviewAvatars;
